import { LOZENGE_HEIGHT, LOZENGE_SPACING } from '../settings/Global';

export default function getLozengeHeight(numRows = 1): number {
    return (
        LOZENGE_HEIGHT * Math.max(0, numRows) +
        LOZENGE_SPACING * Math.max(0, numRows - 1)
    );
}
